import { TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  getArrayTypeReducerGuard
} from "../reducers"

export type SnapPath = {
  branch: string
  seq: number
  screenStateIdx: number
  completed: boolean
}

const reducerAction = {
  branch: actionCreatorTypeGuard<SnapPath, string>("branch", "SnapPath"),
  seq: actionCreatorTypeGuard<SnapPath, number>("seq", "SnapPath"),
  completed: actionCreatorTypeGuard<SnapPath, boolean>("completed", "SnapPath"),
  screenStateIdx: actionCreatorTypeGuard<SnapPath, number>(
    "screenStateIdx",
    "SnapPath"
  ),
  __record: actionCreatorTypeGuard<TypeArray, SnapPath>("SnapPath", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<SnapPath>>(
    "create",
    "__create/SnapPath"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof SnapPath
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapPathAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapPathReducer = reducerTypeGuard<SnapPath>()
  .case(...reducerAction.branch)
  .case(...reducerAction.seq)
  .case(...reducerAction.completed)
  .case(...reducerAction.screenStateIdx)
  .build()
